module.exports = __webpack_public_path__ + "img/dryva-screen-6.f81f9802.png";